/* eslint-disable no-restricted-syntax */

import { getUrlSearchParams } from './urlParser'

function convertQueryParamValue(value, returnType) {
  const isNumber = /^\d+$/.test(value)
  const isBoolean = /^(true|false)$/i.test(value)

  if (returnType) {
    switch (returnType) {
      case 'string':
        return String(value)
      case 'number':
        return Number(value)
      case 'boolean':
        return value.toLowerCase() === 'true'
      case 'array':
        return Array.isArray(value) ? value : [value]
      default:
        return value
    }
  }

  if (isNumber) {
    return Number(value)
  } else if (isBoolean) {
    return value.toLowerCase() === 'true'
  }

  return value
}

export function getFiltersFromUrl(
  searchParams,
  { defaultValues = {}, defaultReturnTypes = {} } = {},
) {
  const filters = {}

  searchParams.forEach((value, key) => {
    const returnType = defaultReturnTypes[key]
    if (Array.isArray(returnType)) {
      filters[key] = searchParams.getAll(key)
    } else {
      filters[key] = convertQueryParamValue(value, returnType)
    }
  })

  for (const key in defaultValues) {
    if (!(key in filters)) {
      filters[key] = defaultValues[key]
    }
  }

  return filters
}

export const removeFalsySearchParams = (obj) => Object.fromEntries(
  Object.entries(obj).filter(([_, value]) => {
    if (!value) return false
    if (Array.isArray(value) && value.length === 0) return false
    return true
  }),
)

export const getUrlFromFilters = (filters) => {
  const searchParams = new URLSearchParams()

  for (const key in filters) {
    if (
      Object.prototype.hasOwnProperty.call(filters, key) &&
      filters[key] !== null &&
      filters[key] !== undefined &&
      filters[key] !== ''
    ) {
      if (Array.isArray(filters[key])) {
        filters[key].forEach((value) => {
          searchParams.append(key, value)
        })
      } else {
        searchParams.set(key, filters[key])
      }
    }
  }
  return `?${searchParams.toString()}`
}

export const handleGetFiltersFromUrl = (search, { defaultValues, defaultReturnTypes } = {}) => {
  const searchParams = getUrlSearchParams(search)
  return getFiltersFromUrl(searchParams, { defaultValues, defaultReturnTypes })
}

export function serializeParams(params) {
  const searchParams = new URLSearchParams()

  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((item) => {
        searchParams.append(key, item)
      })
    } else if (value !== undefined && value !== null) {
      searchParams.append(key, value)
    }
  })

  return searchParams.toString()
}
